export default "__VITE_ASSET__3ZPFHDvI__"